/**
 * @Description 列表
 */

import { FC, ReactNode } from 'react';
import V2Table from '@/common/components/Data/V2Table';
import { ButtonProps } from 'antd';
import styles from '../index.module.less';
import { isNotEmptyAny } from '@lhb/func';
interface TableProps {
  onRefresh?: (value: any) => void
  selectedRowKeys?: any[];
  tableData?: any[];
  setSelectedRowKeys?: (value: any) => void;
  onAction?: (key: string, recoder: any) => void;
  message?: ReactNode;
  onSortOrderChange?: (value: any) => void;
  refreshCurrent?: boolean; // 当前页刷新
  rowSelection?: any;
  onFetch?: () => void;
  filters?: any;
  rowSelectionOperate?: Array<{
    text: string,
    onClick: any,
    icon?: any,
    btnConfig?: ButtonProps
  }>;
  /**
   * @description 从1页重新加载
   */
  reload?: () => void;
  /**
   * @description 从当前页重新加载
   */
   currentReload?: () => void;
   [key: string]: any;
}

const TableList: FC<TableProps> = ({
  onFetch,
  filters,
  refreshCurrent,
  modColumn,
  ...props
}) => {

  const renderLogo = (value, record) => {
    return <span>

      {record?.logo ? <img
        className={styles.brandLogo}
        src={record?.logo}/> : <></>}
      {value || '-'}
    </span>;
  };
  const columns = modColumn?.value === 'brandName' ? [
    {
      key: modColumn?.value,
      title: modColumn?.label,
      dragChecked: true,
      importWidth: true,
      width: 223,
      render: renderLogo
    },
    {
      key: 'name',
      title: '门店名称',
      dragChecked: true,
      importWidth: true,
      minWidth: 227,
    },
    +filters.type === 2 ? {
      key: 'openDate',
      title: '开业时间',
      width: 140,
      importWidth: true,
    } : undefined,
    {
      key: 'distance',
      title: '距离',
      dragChecked: true,
      width: 72,
      importWidth: true,
      forceTooltipRender(_: string) {
        return isNotEmptyAny(_) ? (_ + 'm') : '-';
      },
      render(_: string) {
        return isNotEmptyAny(_) ? (_ + 'm') : '-';
      }
    },
  ].filter(Boolean) : [
    {
      key: 'name',
      title: '门店名称',
      dragChecked: true,
      importWidth: true,
      minWidth: 223,
    },
    {
      key: modColumn?.value,
      title: modColumn?.label,
      dragChecked: true,
      importWidth: true,
      width: 227,
      render: renderLogo
    },
    {
      key: 'distance',
      title: '距离',
      dragChecked: true,
      width: 72,
      forceTooltipRender(_: string) {
        return isNotEmptyAny(_) ? (_ + 'm') : '-';
      },
      render(_: string) {
        return isNotEmptyAny(_) ? (_ + 'm') : '-';
      }
    }
  ];

  return (
    <>
      <div style={[1, 2].includes(+filters.type) ? { marginTop: 10 } : {}}></div>
      <V2Table
        key={modColumn?.value + filters.type}
        pageSize={10}
        paginationConfig={{
          simple: true,
        }}
        rowKey='name'
        filters={filters}
        scroll={{ x: 'max-content' }}
        defaultColumns={columns}
        onFetch={onFetch}
        refreshCurrent={refreshCurrent}
        voluntarilyEmpty
        hideColumnPlaceholder
        {...props}
      />
    </>
  );
};

export default TableList;
